App.OrderHistoryMiniPopupComponent = Em.Component.extend
  classNames: [ 'order-history-mini-popup' ]

  order: null
  historyEvents: null
  refreshOnInit: false
  active: false

  allowedFields: [ 'status', 'pick_up_at', 'cooking_start_at', 'delivery_at', 'courier_id' ]

  normalizeHistory: (payload) ->
    allowedFields = @get('allowedFields')

    events = _.chain(payload.orders)
    .map (e) ->
      api_user_name: e.api_user_name
      created_at: e.created_at
      changes:   _.pick(e.changes, allowedFields)
    .reject (e) -> _.isEmpty(e.changes)
    .value()

  resolveHistory: (->
    if @get('active')
      @set('isLoading', true)

      Em.run.later =>
        order = @get('order')
        return unless order

        order.loadLogs()
        .then (es) =>
          @set('historyEvents', @normalizeHistory(es))

        .finally =>
          @set('isLoading', false)
      , 300 # sorry
  ).observes('active')

  checkRefreshOnInit: (->
    if @get('refreshOnInit')
      @resolveHistory()
  ).on('init')